export default __webpack_public_path__ + "static/media/Imagen4.ba692e83.jpg";